import type { FieldSchema } from '../types';

/**
 * Returns the label of the first required field that is still empty,
 * or null when everything required is filled in.
 *
 * Editors save via button clicks rather than form submission, so the HTML
 * `required` attribute never fires — this is the check that actually runs.
 */
export function firstMissingRequiredField(
  fields: Record<string, FieldSchema>,
  data: Record<string, unknown>,
): string | null {
  for (const [name, field] of Object.entries(fields)) {
    if (!field.required) continue;
    const val = data[name];
    if (val == null || (typeof val === 'string' && !val.trim())) {
      return field.label;
    }
    if (Array.isArray(val) && val.length === 0) {
      return field.label;
    }
  }
  return null;
}
